import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

interface Props {
    content: string;
}

const MarkdownRenderer: React.FC<Props> = ({ content }) => {
    const [html, setHtml] = useState<string>('');

    useEffect(() => {
        const renderMarkdown = async () => {
            const rawHtml = await marked.parse(content); // 注意这是异步的
            //不需要过滤，因为内容不是用户产生的
            //const cleanHtml = DOMPurify.sanitize(rawHtml);
            setHtml(rawHtml);
        };

        renderMarkdown();
    }, [content]);

    return (
        <div
            className="markdown-body"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
export default MarkdownRenderer;